import { useSelector } from 'react-redux'
import { useCallback, useState } from 'react'
import Dialog from '../../atoms/feedback/Dialog'
import { JobSelectors } from '../../../store/job/selectors'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import CheckLabel from '../../atoms/inputs/CheckLabel'
import FieldView from '../../molecules/display/FieldView'
import Button from '../../atoms/inputs/Button'

type Props = {
  open: boolean
  onChange: (ids: string[]) => void
  onClose: () => void
}

export default function ClientSearchConstructionSelectDialog({ open, onChange, onClose }: Props) {
  const industryTypes = useSelector(JobSelectors.industryTypes)
  const [constructionIds, setConstructionIds] = useState<string[]>([])

  const handleSelect = useCallback(
    (constructionId: string) => (selected: boolean) => {
      if (selected) {
        setConstructionIds([...constructionIds, constructionId])
      } else {
        setConstructionIds(constructionIds.filter((id) => id !== constructionId))
      }
    },
    [constructionIds]
  )

  const handleSetting = () => {
    onChange(constructionIds)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <FlexColumn>
        <FlexColumn height="calc(100vh - 240px)" scroll space={2}>
          {industryTypes.map((industry) => (
            <FieldView key={industry.id} label={industry.name}>
              <FlexRow wrap>
                {industry.constructionTypes.map((construction) => (
                  <CheckLabel
                    key={construction.id}
                    label={construction.name}
                    selected={constructionIds.includes(construction.id)}
                    onChange={handleSelect(construction.id)}
                  />
                ))}
              </FlexRow>
            </FieldView>
          ))}
        </FlexColumn>
        <FlexRow justify="flex-end">
          <Button onClick={handleSetting}>設定</Button>
        </FlexRow>
      </FlexColumn>
    </Dialog>
  )
}
